import { useQuery } from '@apollo/react-hooks';
import React from 'react';
import { Link } from 'react-router-dom';
import brandLinkQuery from './BrandLinkQuery.gql';

const BrandLink = ({ brand }) => {
  const { data, loading, error } = useQuery(brandLinkQuery, {
    variables: { id: 177 }
  });
  if (loading || error) {
    return null;
  }
  const match = data?.category?.subcategories?.find(subcat =>
    subcat?.name?.toLowerCase().startsWith(brand.toLowerCase())
  );
  return (
    <>
      {match ? (
        <Link to={match.primaryRoute.path} className="small-title">
          {brand}
        </Link>
      ) : (
        <span className="small-title">{brand}</span>
      )}
    </>
  );
};

export default BrandLink;
